export class ValidationResponse {
  constructor(public errors: any) {}
}
